import { derived, writable } from 'svelte/store';
import type { Readable } from 'svelte/store';
import type { IMeResponseModel } from '$lib/models/IMeResponseModel';

const userAccountStore = writable<Partial<IMeResponseModel>>({});

const isSuperAdminStore: Readable<boolean> = derived(userAccountStore, ($userAccountStore) => {
	return $userAccountStore.roleName === 'SuperAdmin';
});

const userRole: Readable<IMeResponseModel['roleName'] | undefined> = derived(
	userAccountStore,
	($userAccountStore) => {
		return $userAccountStore.roleName ? $userAccountStore.roleName : undefined;
	}
);

export { userAccountStore, isSuperAdminStore, userRole };
